import React from 'react';
import img1 from '../assets/img.jpg';
import imgCirculoYellow from '../assets/circulo1.svg';
import imgCirculoBlue from '../assets/circulo2.svg';
import imgBallBlue from '../assets/ballBlue.svg';
import imgBallYellow from '../assets/ballYellow.svg';
import styled from 'styled-components';
import Colors from 'enums/Colors';
import StyledGlobal from '../Alfabetizacao360NewDetail.styled';
import { IsCustomMaxWidth } from 'core/util/WindowSize';

const Styled = {
    Container: styled.div`
        position: relative;
        display: flex;
        height: 580px;

        @media screen and (max-width: 1150px) {
            height: 700px;
        }

        @media screen and (max-width: 850px) {
            flex-direction: column-reverse;
            height: fit-content;
            margin-bottom: 22px;
        }

        @media screen and (max-width: 820px) {
            height: 900px;
        }
        @media screen and (max-width: 500px) {
            height: fit-content;
        }
    `,

    Content: styled.div`
        display: flex;
        overflow: hidden;
        width: 50%;
        @media screen and (max-width: 850px) {
            width: 100%;
        }
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 48px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        color: ${Colors.Blue};
    `,

    Description: styled.p`
        color: ${Colors.Blue};
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        max-width: 355px;
    `,

    Img: styled.img`
        position: relative;
        top: -80px;
        width: 1920px;
        height: 820px;
        border-top-left-radius: 420px;
        border-bottom-left-radius: 420px;

        object-fit: cover;

        @media screen and (max-width: 1920px) {
            padding-left: 0px;
        }

        @media screen and (max-width: 850px) {
            top: 0;
            height: 404px;
            left: 70px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 320px;
        }

        @media screen and (max-width: 390px) {
            left: 0px;
        }
    `,

    BallSolftBlue: styled.img`
        position: absolute;
        top: 131px;
        left: 196px;
        z-index: 10;

        @media screen and (max-width: 1800px) {
            left: 80px;
        }

        @media screen and (max-width: 1565px) {
            left: 20px;
        }
    `,

    BallBlue: styled.img`
        position: absolute;
        bottom: -60px;
        left: 50%;
        z-index: 10;

        @media screen and (max-width: 880px) {
            display: none;
        }
    `,

    BallYellow: styled.img`
        position: absolute;
        top: 500px;
        right: 980px;
        z-index: 10;

        @media screen and (max-width: 1920px) {
            right: 40%;
        }

        @media screen and (max-width: 850px) {
            display: none;
        }
    `,

    BallCircleYellow: styled.img`
        position: absolute;
        top: 200px;
        left: -61px;
        z-index: 10;

        @media screen and (max-width: 1800px) {
            left: -120px;
        }
        @media screen and (max-width: 1670px) {
            left: -160px;
        }
        @media screen and (max-width: 1600px) {
            left: -220px;
        }

        @media screen and (max-width: 850px) {
            top: 100px;
            left: -200px;
        }

        @media screen and (max-width: 570px) {
            top: 0px;
        }
    `,

    ContentInfo: styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 116px;
        padding-right: 80px;

        @media screen and (max-width: 1000px) {
            position: relative;
            height: 700px;
        }

        @media screen and (max-width: 850px) {
            padding-right: 0px;
            left: 0px;
            margin-top: 20px;
            height: fit-content;
        }

        @media screen and (max-width: 500px) {
            padding-left: 20px;
        }
    `,
};

interface IFirstSession {
    gotoSection: (value: string) => void;
}

const FirstSession: React.FC<IFirstSession> = ({ gotoSection }) => {
    const isMax1600 = IsCustomMaxWidth(1600);
    const isMax500 = IsCustomMaxWidth(500);

    return (
        <Styled.Container>
            <Styled.BallCircleYellow src={imgCirculoYellow} />
            <Styled.BallSolftBlue src={imgBallBlue} alt="" />
            <Styled.BallYellow src={imgBallYellow} alt="" />
            <Styled.BallBlue src={imgCirculoBlue} alt="" />

            <Styled.Content style={{ justifyContent: 'flex-start', paddingLeft: isMax500 ? '20px' : isMax1600 ? '80px' : '280px' }}>
                <Styled.ContentInfo>
                    <Styled.Title>Alfabetização</Styled.Title>
                    <Styled.Description
                        dangerouslySetInnerHTML={{
                            __html: `
                    Há tempos falamos dos desafios da alfabetização no Brasil. Mas você sabe o que está envolvido nesta busca pela alfabetização e por que temos ainda esse grande desafio a ser superado? 
                    <br /><br />
                    <strong>Venha percorrer essa trilha sobre Alfabetização e conheça nossos conteúdos para te ajudarem nessa missão.</strong>
                    
                    
                    `,
                        }}
                    />
                    <StyledGlobal.ButtonYellow onClick={() => gotoSection('SecoundSession')}>Conheça os conteúdos</StyledGlobal.ButtonYellow>
                </Styled.ContentInfo>
            </Styled.Content>
            <Styled.Content>
                <Styled.Img src={img1} alt="" />
            </Styled.Content>
        </Styled.Container>
    );
};

export default FirstSession;
